import { render, staticRenderFns } from "./RecruitmentPayoutDetails.vue?vue&type=template&id=04c2fd9d"
import script from "./RecruitmentPayoutDetails.vue?vue&type=script&lang=js"
export * from "./RecruitmentPayoutDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports